
import Vue from "vue";
import moment from "moment";
import Component from "vue-class-component";
import { saveAs } from "file-saver";
import { AxiosResponse } from "axios";
import { Action, State } from "vuex-class";

import { TracerStudyModel } from "@/models/tracerstudy.model";

import PieChart from "@/components/charts/PieChart.vue";
import ModalResponsesIndividual from "./modal/ModalResponsesIndividual.vue";
import toast from "@/functions/toast.function";
import i18n from "@/i18n";

@Component({
  components: {
    PieChart,
    ModalResponsesIndividual,
  },
})
export default class RespondentResults extends Vue {
  /* VUEX */

  /* ACTIONS */
  @Action("actionGetRespondentResult", { namespace: "tracerstudy" })
  private actionGetRespondentResult: any;
  @Action("actionCloseTracerStudy", { namespace: "tracerstudy" })
  private actionCloseTracerStudy: any;
  @Action("actionDownloadRespondentResult", { namespace: "tracerstudy" })
  private actionDownloadRespondentResult: any;
  @Action("actionGetRespondentPerCandidate", { namespace: "tracerstudy" })
  private actionGetRespondentPerCandidate: any;

  /* STATE */
  @State("tracerStudy", { namespace: "tracerstudy" })
  private tracerStudy: TracerStudyModel;
  @State("respondentResult", { namespace: "tracerstudy" })
  private respondentResult: any;
  @State("respondentByReach", { namespace: "tracerstudy" })
  private respondentByReach: any;
  @State("respondentByMajor", { namespace: "tracerstudy" })
  private respondentByMajor: any;
  @State("respondentByLength", { namespace: "tracerstudy" })
  private respondentByLength: any;
  @State("respondentByGPA", { namespace: "tracerstudy" })
  private respondentByGPA: any;

  /* WATCHER */

  /* INITIALIZATION */
  private showAcceptRespon: boolean = false;
  private showModalIndividual: boolean = false;
  private chartList: Array<any> = [];

  private get isHaveRespondent() {
    if (this.respondentResult.total_respondent_complete > 0) {
      return true;
    }
    return true;
  }

  private created() {
    this.loadRespondent();
  }

  /* METHODS */
  private loadRespondent() {
    const { tracer_id } = this.$route.params;
    this.actionGetRespondentResult({
      params: { tracer_id },
      success: (response: AxiosResponse) => {
        this.setupRespondentByReach();
        this.setupRespondentByMajor();
        this.setupRespondentByLength();
        this.setupRespondentByGPA();
      },
    });
  }

  private setupRespondentByReach() {
    const [itemDataset] = this.respondentByReach.datasets;

    this.chartList.push({
      name: this.$t("respondent_reach"),
      pieData: {
        labels: this.respondentByReach.labels,
        datasets: [
          {
            backgroundColor: this.pieColors,
            label: itemDataset.label,
            data: itemDataset.data,
          },
        ],
      },
      pieOption: this.pieOption,
    });
  }

  private setupRespondentByMajor() {
    const [itemDataset] = this.respondentByMajor.datasets;

    this.chartList.push({
      name: this.$t("respondent_major"),
      pieData: {
        labels: this.respondentByMajor.labels,
        datasets: [
          {
            backgroundColor: this.pieColors,
            label: itemDataset.label,
            data: itemDataset.data,
          },
        ],
      },
      pieOption: this.pieOption,
    });
  }

  private setupRespondentByLength() {
    const [itemDataset] = this.respondentByLength.datasets;

    this.chartList.push({
      name: this.$t("respondent_length"),
      pieData: {
        labels: this.respondentByLength.labels,
        datasets: [
          {
            backgroundColor: this.pieColors,
            label: itemDataset.label,
            data: itemDataset.data,
          },
        ],
      },
      pieOption: this.pieOption,
    });
  }

  private setupRespondentByGPA() {
    const [itemDataset] = this.respondentByGPA.datasets;

    this.chartList.push({
      name: this.$t("repondent_gpa"),
      pieData: {
        labels: this.respondentByGPA.labels,
        datasets: [
          {
            backgroundColor: this.pieColors,
            label: itemDataset.label,
            data: itemDataset.data,
          },
        ],
      },
      pieOption: this.pieOption,
    });
  }

  private onAcceptRespon() {
    // set tracer status to expired
    this.tracerStudy.status = 3;
    this.actionCloseTracerStudy({
      params: this.tracerStudy,
      callback: () => {
        this.showAcceptRespon = false;
        this.$router.push({ name: "tracerStudy" });
      },
    });
  }

  private actionDownload() {
    const { id, title } = this.tracerStudy;
    this.actionDownloadRespondentResult({
      params: { tracer_id: id, title },
      success: (response: AxiosResponse) => {
        saveAs(response.data, `${title}.xlsx`, { autoBom: true });
      },
    });
  }

  private actionIndividual() {
    const { id } = this.tracerStudy;
    this.actionGetRespondentPerCandidate({
      params: { tracer_id: id },
      success: (res: AxiosResponse) => {
        const { candidate } = res.data;

        if (candidate) {
          this.showModalIndividual = true;
        } else {
          toast.warning(i18n.t("tracer_study_no_response"));
        }
      },
    });
  }

  private toDate(date: string) {
    return moment(date).format("DD MMM YYYY");
  }

  // PIE OPTION
  private pieOption = {
    responsive: true,
    maintainAspectRatio: true,
    legend: {
      display: false,
    },
  };

  private pieColors = [
    "#73d47f",
    "#fed85e",
    "#fb7764",
    "#ffa996",
    "#757ab2",
    "#3cbab2",
    "#7ab8eb",
    "#facb86",
    "#af4bce",
    "#db4cb2",
    "#dbb081",
    "#8ed962",
    "#f1929f",
    "#619fd2",
    "#ee9a3a",
  ];
}
